import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck, faQrcode, faList, faListUl } from '@fortawesome/free-solid-svg-icons';
import './LeadPulse.css';
import leadpulseimage from '../../assets/pageimages/LeadPulse.webp';

function LeadPulseHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>LeadPulse</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
              <div className="bottom-buttons-box"><Link to="/leadpulse-itemlist" className="top-button-link"><FontAwesomeIcon icon={faList} className="leadpulse-bottomlink-style" />Items List</Link></div>
              <div className="bottom-buttons-box"><Link to="/leadpulse-createcode" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="leadpulse-bottomlink-style" />Generate Code</Link></div>
              <div className="bottom-buttons-box"><Link to="/leadpulse-fakereport" className="top-button-link"><FontAwesomeIcon icon={faListUl} className="leadpulse-bottomlink-style" />Fake Report</Link></div>
              <div className="bottom-buttons-box"><Link to="/leadpulse-scan" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="leadpulse-bottomlink-style" />LeadPulse Scan</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="leadpulse-id" src={leadpulseimage} alt="LeadPulse Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default LeadPulseHome;
